module.exports = __webpack_public_path__ + "static/media/ic_movie.ba1cacf5.svg";